<template>
    <div v-if="object" class="filter-secondary-block hidden-filter" :ref="system_name">
        <div class="filter-title-row">  
            <button @click="closeModal" type="button" class="btn-back-filter">
                <svg class="icon">
                    <use xlink:href="/img/front/icons/svgmap.svg#arrow-left" />
                </svg>
                <span class="filter-title">{{ name }}</span>
            </button>
        </div>
        <div class="filter-body">
            <div class="filter-search-block">
                <div class="filter-search-row">
                    <div class="filter-name">
                        {{ all_name }}
                    </div>
                </div>
                <div class="list-choose">
                    <div class="list-choose-block">
                        <label v-for="item in object" :key="item.id" class="label-checkbox">
                            <input
                                @input="checkItem(item.id)"
                                :checked="checkItemCheked(item.id)"
                                :disabled="!enableCheckbox(item.id)"
                            type="checkbox">
                            <span class="checkbox">
                                <svg class="icon">
                                    <use xlink:href="/img/front/icons/svgmap.svg#check"/>
                                </svg>
                            </span>
                            <span v-if="item.meta" class="text">
                                {{ item.meta.title }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: {
        object: {
            requeired: true
        },
        props_checked_data: {
            requeired: true
        },
        name: {
            requeired: true
        },
        all_name: {
            requeired: true
        },
        system_name: {
            requeired: true
        },
        includer: {
            requeired: true
        }
    },
    data() {
        return {
            checked_data: this.props_checked_data
        }
    },
    watch: {
        props_checked_data(new_value, old_value) {
            this.checked_data = new_value;
        }
    },
    methods: {
        closeModal() {
            this.$emit("close", this.system_name);
        },
        checkItem(id) {
            if (this.checked_data.includes(id)) {
                this.checked_data = this.checked_data.filter(element => {
                    return element !== id;
                });
            } else {
                this.checked_data.push(id);
            }
            this.$emit("change", { name: this.system_name, content: this.checked_data });
        },
        checkItemCheked(id) {
            if (this.checked_data.includes(id)) {
                return true;
            } else {
                return false;
            }
        },
        idIncluder(id, property) {
            if (this.includer !== null && this.includer.hasOwnProperty(property)) {
                if (this.includer[property].includes(id)) {
                    return true;
                }
            }
            return false;
        },
        enableCheckbox(id) {
            if (this.idIncluder(id, this.system_name) || this.checked_data.includes(id)) {
                return true;
            }
        },
    }
}
</script>